// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../../common/utils.res.js");
var Question$ReactHooksTemplate = require("../Question.res.js");
var RichTextEditor$ReactHooksTemplate = require("../../common/RichTextEditor.res.js");

function QuestionPageEditorCard(props) {
  var onQuestionChange = props.onQuestionChange;
  var question = props.question;
  var textLen = Utils$ReactHooksTemplate.stripHtml(Question$ReactHooksTemplate.text(question)).length;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("section", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Question Content",
                                    className: "sb-edit-card-kicker"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("span", {
                                                    children: "Question Text"
                                                  }),
                                              JsxRuntime.jsx("span", {
                                                    children: String(textLen) + (" / " + String(100)),
                                                    className: "sb-field-count"
                                                  })
                                            ],
                                            className: "sb-field-label"
                                          }),
                                      JsxRuntime.jsx(RichTextEditor$ReactHooksTemplate.make, {
                                            value: Question$ReactHooksTemplate.text(question),
                                            onChange: (function (html) {
                                                Curry._1(onQuestionChange, Question$ReactHooksTemplate.setText(question, html));
                                              }),
                                            placeholder: "Enter question text",
                                            label: "",
                                            minHeight: "48px",
                                            singleLine: true,
                                            showAlignment: false,
                                            showLists: false
                                          })
                                    ],
                                    className: "sb-field-group"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("span", {
                                                  children: "Description (Optional)"
                                                }),
                                            className: "sb-field-label"
                                          }),
                                      JsxRuntime.jsx(RichTextEditor$ReactHooksTemplate.make, {
                                            value: Question$ReactHooksTemplate.description(question),
                                            onChange: (function (html) {
                                                Curry._1(onQuestionChange, Question$ReactHooksTemplate.setDescription(question, html));
                                              }),
                                            placeholder: "Enter description",
                                            label: "",
                                            minHeight: "96px"
                                          })
                                    ],
                                    className: "sb-field-group"
                                  })
                            ],
                            className: "sb-edit-section"
                          }),
                      JsxRuntime.jsxs("section", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Question Settings",
                                    className: "sb-edit-card-kicker"
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: Question$ReactHooksTemplate.toEditorBlock(onQuestionChange, question, props.quizMode),
                                    className: "sb-question-type-settings-body"
                                  })
                            ],
                            className: "sb-edit-section sb-question-type-settings"
                          })
                    ],
                    className: "sb-edit-card",
                    onClick: (function ($$event) {
                        $$event.stopPropagation();
                      })
                  }),
              className: "sb-center-editor"
            });
}

var make = QuestionPageEditorCard;

exports.make = make;
/* react/jsx-runtime Not a pure module */
